import { ShapeState } from '../../../../../../cross-team-shared/annotation/shared/state/shape-state';
import { ObjectWith } from '../../../../../../cross-team-shared/types/misc';
import { AnswerOption } from '../../../../../../team-apis/otterdam/answer-option';
import {
  FrameSpecificTag,
  Point2D,
} from '../../../../../../team-apis/otterdam/answers/shape-typings';

export function buildRectanglePoints(
  [left, top]: Point2D,
  [right, bottom]: Point2D,
): Point2D[] {
  return [
    [left, top],
    [right, top],
    [right, bottom],
    [left, bottom],
  ];
}

export function getShapeWithFusedTags(
  fusedAnswerOptions: AnswerOption[],
  shape: ShapeState,
) {
  // @ts-ignore -- fix me
  const dynamicTags = filterTags(shape.dynamic_tags, fusedAnswerOptions);
  const staticTags = filterTags(shape.tags, fusedAnswerOptions);
  return {
    ...shape,
    tags: staticTags,
    dynamic_tags: dynamicTags,
  };
}

export function filterTags(
  tags: ObjectWith<FrameSpecificTag[]>,
  answerOptions: AnswerOption[],
) {
  const validTags: ObjectWith<FrameSpecificTag[]> = {};
  for (const tag in tags) {
    if (answerOptions.find(({ name }) => name === tag)) {
      validTags[tag] = tags[tag];
    }
  }
  return validTags;
}
